export const ADVERBS = [
    "Accordingly", "Actually", "Almost", "Always", "Also", "Already", "Back", "Better", "Certainly", "Clearly", 
    "Completely", "Consequently", "Constantly", "Definitely", "Differently", "Directly", "Early", "Easily", "Else", "Enough", 
    "Especially", "Even", "Eventually", "Exactly", "Extremely", "Fairly", "Far", "Fast", "Finally", "First", 
    "Frequently", "Further", "Generally", "Greatly", "Hard", "Hardly", "Here", "Highly", "However", "Immediately", "Indeed", 
    "Instead", "Just", "Late", "Later", "Likely", "Little", "Long", "Low", "Mainly", "Maybe", 
    "Merely", "More", "Moreover", "Most", "Much", "Nearly", "Never", "Next", "No", "Not", 
    "Now", "Often", "Only", "Particularly", "Perfectly", "Perhaps", "Pretty", "Probably", "Quite", "Rarely", 
    "Rather", "Really", "Recently", "Relatively", "Right", "Seldom", "Shortly", "Significantly", "Similarly", "Simply", 
    "Slowly", "So", "Sometimes", "Soon", "Still", "Strongly", "Suddenly", "Surely", "Then", "There", 
    "Therefore", "Today", "Together", "Too", "Totally", "Truly", "Usually", "Very", "Well", "When", 
    "Where", "Why", "Yet"
];

export const ADJECTIVES = [
    "Good", "New", "First", "Last", "Long", "Great", "Little", "Own", "Old", "Right",
    "Big", "High", "Different", "Small", "Large", "Next", "Early", "Young", "Important", "Few", 
    "Public", "Bad", "Same", "Able", "Strong", "Free", "Full", "Sure", "Low", "Clear", 
    "Easy", "Hard", "Certain", "Human", "True", "Possible", "Whole", "Real", "Short", "Common", 
    "Necessary", "Single", "Present", "Personal", "Open", "Dark", "Special", "Difficult", "Simple",
    "Ready", "White", "Free", "Right", "Left", "Late", "General", "Full", "Far", "Main", 
    "Black", "Particular", "Likely", "Foreign", "National", "Correct", "Social", "Only", "Small", 
    "Local", "Sure", "Past", "Wrong", "Major", "Political", "Similar", "Recent", "Private", "Best",
    "Better", "Dry", "Cold", "Warm", "Central", "Financial", "Wide", "Close", "Interesting", "Fine", 
];

export const NOUNS = [
    "Dog", "Cat", "Horse", "Cow", "Pig", "Sheep", "Chicken", "Duck", "Goat", "Rabbit",
    "Lion", "Tiger", "Elephant", "Giraffe", "Zebra", "Bear", "Monkey", "Wolf", "Fox", "Deer",
    "Dolphin", "Whale", "Shark", "Octopus", "Jellyfish", "Starfish", "Penguin", "Eagle", "Owl", "Hawk",
    "Snake", "Lizard", "Turtle", "Frog", "Toad", "Spider", "Ant", "Bee", "Butterfly", "Mosquito",
    "Hamster", "Guinea pig", "Squirrel", "Rat", "Mouse", "Beaver", "Otter", "Raccoon", "Skunk", "Possum",
    "Koala", "Kangaroo", "Panda", "Cheetah", "Leopard", "Jaguar", "Gorilla", "Chimpanzee", "Orangutan", "Baboon",
    "Crocodile", "Alligator", "Rhinoceros", "Hippopotamus", "Camel", "Llama", "Donkey", "Mule", "Yak", "Buffalo",
    "Peacock", "Parrot", "Swan", "Goose", "Pigeon", "Seagull", "Sparrow", "Robin", "Crow", "Blue jay",
    "Lobster", "Crab", "Shrimp", "Clam", "Oyster", "Salmon", "Trout", "Tuna", "Cod", "Herring"
];